import React from 'react';
import { AccordionBodyItemView } from 'component/Accordion';
import { ReactComponent as CheckBoxIcon } from 'assets/images/icons/check_box_24(1).svg';

export const ExplosivesView = (props) => {
  const { formData } = props;

  return (
    <AccordionBodyItemView
      accordionSubId="3.8"
      titleUA="Вибухові речовини, порохи"
      titleEN="Explosives"
      children={
        formData.info.hazard_type.explosives && <CheckBoxIcon />
      }
    />
  );
};
